var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoldGiftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#goldGiftIcon_svg__clip0_44063_86520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.125a3.125 3.125 0 116.25 0 3.125 3.125 0 116.25 0v.007c0 .088 0 .338-.047.618h2.547A1.25 1.25 0 0120 5v1.25a1.25 1.25 0 01-1.25 1.25H1.25A1.25 1.25 0 010 6.25V5a1.25 1.25 0 011.25-1.25h2.547a3.71 3.71 0 01-.047-.618v-.007zm1.335.625H8.75v-.625a1.875 1.875 0 10-3.75 0c0 .106.003.342.056.538.008.03.017.059.029.087zm6.165 0h3.665a.707.707 0 00.029-.087c.053-.196.056-.432.056-.538a1.875 1.875 0 10-3.75 0v.625zm7.5 5v9.375A1.875 1.875 0 0116.875 20H11.25V8.75h7.5zM3.125 20a1.875 1.875 0 01-1.875-1.875V8.75h7.5V20H3.125z",
    fill: "url(#goldGiftIcon_svg__paint0_linear_44063_86520)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGiftIcon_svg__paint0_linear_44063_86520",
    x1: 0,
    y1: 8.75,
    x2: 20,
    y2: 8.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "goldGiftIcon_svg__clip0_44063_86520"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgGoldGiftIcon;